import { Model, Attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class EmailConfirmation extends ApplicationRecord {
  static jsonapiType = 'email-confirmations';

  @Attr() uid: string;
  @Attr() token: string;
  @Attr() email: string;
}
